import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Calendar, MapPin, AlertTriangle, Car, Navigation } from 'lucide-react';
import { PURPOSE_OPTIONS, STATUS_COLORS, getDays, calcTotalExpense } from './constants';

export const TravelPlanCard = ({ plan, onClick }) => {
  const purpose = PURPOSE_OPTIONS.find(p => p.value === plan.purpose)?.label || plan.purpose;
  const days = getDays(plan.start_date, plan.end_date);
  const totalExp = calcTotalExpense(plan.daily_expenses);

  return (
    <Card data-testid={`plan-card-${plan.id}`} className="border border-border/60 shadow-sm hover:shadow-md transition-all cursor-pointer" onClick={onClick}>
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-2">
          <Badge className={`text-[10px] ${STATUS_COLORS[plan.status]}`}>{plan.status.replace('_', ' ')}</Badge>
          <span className="text-xs text-slate-400">{days} day{days > 1 ? 's' : ''}</span>
        </div>
        <h3 className="text-sm font-bold text-slate-900 mb-1">{plan.visit_type === 'client_visit' ? 'Client Visit' : 'Business Location Visit'}</h3>
        <p className="text-xs text-slate-500">{purpose}</p>
        <div className="flex items-center gap-2 mt-2 text-xs text-slate-400"><Calendar className="w-3 h-3" /> {plan.start_date} - {plan.end_date}</div>
        <div className="flex items-center gap-2 mt-1 text-xs text-slate-400">
          <MapPin className="w-3 h-3" /> {(plan.locations || []).length} location{(plan.locations || []).length !== 1 ? 's' : ''}
          <span className="ml-auto font-semibold text-slate-600">Rs.{totalExp.toLocaleString()}</span>
        </div>
        {plan.mode_of_travel && (
          <div className="flex items-center gap-2 mt-1 text-xs text-slate-400">
            <Car className="w-3 h-3" /> {plan.mode_of_travel}
            {plan.total_distance_km > 0 && <span className="flex items-center gap-1"><Navigation className="w-3 h-3" /> {plan.total_distance_km} km</span>}
          </div>
        )}
        {plan.deviations?.length > 0 && <div className="flex items-center gap-1 mt-2 text-xs text-amber-600"><AlertTriangle className="w-3 h-3" /> {plan.deviations.length} deviation(s)</div>}
      </CardContent>
    </Card>
  );
};
